import {until} from 'lit-html/directives/until';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';

const dynamicCss = ['.text-blue', '.text-primary', '.text-muted', '.text-success', '.ai-inactive', '.ai-target', '.ai-trophy'];

export default (ctx, html) => html`
    <div class="border action-item align-items-center d-flex flex-direction-row ${ctx.isClickable ? 'cursor-pointer' : ''}" @click="${ctx.onClick}">
      <div class="button-image">
        ${unsafeHTML(ctx.icon)}
      </div>
      <div class="button-content d-flex flex-grow-1">
        <div class="align-self-center h1 mb-0 mx-3">${ctx.count}</div>
        <div class="action-item-content align-self-center font-weight-semibold">${until(ctx.message)}</div>
        ${ctx.isClickable ? html`<img height="17" src="${require('@assets/images/chevron-blue-right.webp')}" class="align-self-center ml-2"/>` : ''}
      </div>
    </div>
`;
